module.exports = __webpack_public_path__ + "static/media/logo-zendesk.0cec2e54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-zendesk.png
// module id = 1312
// module chunks = 17